/* Cardio360 PDP · comportamento pagina. Nessuna dipendenza. */
(function () {
  var root = document.getElementById('c360');
  if (!root) return;
  var form = document.getElementById('c360-buy');
  var sticky = document.getElementById('c360-sticky');
  var stickyPrice = document.getElementById('c360-sticky-price');
  var atc = document.getElementById('c360-atc');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Opzioni d'acquisto */
  var opts = root.querySelectorAll('.opt');
  function syncOpts() {
    opts.forEach(function (o) {
      var on = o.querySelector('input').checked;
      o.classList.toggle('is-on', on);
      if (on && stickyPrice) {
        stickyPrice.textContent = o.dataset.price + (o.dataset.opt === 'sub' ? ' · abbonamento' : '');
      }
    });
  }
  opts.forEach(function (o) { o.querySelector('input').addEventListener('change', syncOpts); });
  syncOpts();

  /* Quantità */
  var qty = form && form.querySelector('input[name="quantity"]');
  root.querySelectorAll('[data-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      var n = Math.min(6, Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.qty, 10)));
      qty.value = n;
    });
  });

  /* Galleria */
  var main = document.getElementById('c360-main-img');
  var seal = document.getElementById('c360-seal');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('.thumb'));
  var cur = 0;
  function show(i) {
    if (!main || !thumbs.length) return;
    cur = (i + thumbs.length) % thumbs.length;
    var t = thumbs[cur];
    if (t.dataset.srcset) main.srcset = t.dataset.srcset;
    main.src = t.dataset.src;
    if (t.dataset.alt) main.alt = t.dataset.alt;
    thumbs.forEach(function (x) { x.classList.toggle('is-on', x === t); });
    if (seal) seal.classList.toggle('is-hidden', cur !== 0);
    if (t.scrollIntoView && t.parentNode.scrollWidth > t.parentNode.clientWidth) {
      t.parentNode.scrollTo({ left: t.offsetLeft - t.parentNode.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
    }
  }
  thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
  /* swipe sulla foto principale */
  if (main && thumbs.length > 1) {
    var sx = null, sy = null;
    main.parentNode.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    main.parentNode.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(cur + (dx < 0 ? 1 : -1));
      sx = null;
    }, { passive: true });
  }

  /* Carrello: AJAX + drawer del tema, fallback al submit classico */
  function openDrawer(data) {
    if (typeof window.aovCartDrawerUpdateAndOpen === 'function') { window.aovCartDrawerUpdateAndOpen(); return true; }
    if (typeof window.aovCartDrawerOpen === 'function') {
      if (typeof window.aovCartDrawerUpdate === 'function') window.aovCartDrawerUpdate();
      window.aovCartDrawerOpen(); return true;
    }
    var cd = document.querySelector('cart-drawer');
    if (cd) { if (data && cd.renderContents) cd.renderContents(data); if (cd.open) cd.open(); return true; }
    return false;
  }
  function openDrawerRetry(data, n) {
    if (openDrawer(data)) return;
    if (n > 0) setTimeout(function () { openDrawerRetry(data, n - 1); }, 200);
    else window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart';
  }
  var busy = false;
  if (form && window.fetch) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;
      busy = true;
      var buttons = document.querySelectorAll('button[form="c360-buy"], #c360-atc');
      buttons.forEach(function (b) { b.classList.add('is-loading'); });
      var plan = form.querySelector('input[name="selling_plan"]:checked');
      var item = { id: Number(form.querySelector('input[name="id"]').value), quantity: Math.max(1, parseInt(qty.value, 10) || 1) };
      if (plan && plan.value) item.selling_plan = Number(plan.value);
      var body = { items: [item] };
      var cd = document.querySelector('cart-drawer');
      if (cd && cd.getSectionsToRender) {
        body.sections = cd.getSectionsToRender().map(function (s) { return s.section || s.id; }).filter(Boolean).join(',');
        body.sections_url = window.location.pathname;
      }
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (!r.ok) throw new Error('add');
        return r.json();
      }).then(function (data) {
        buttons.forEach(function (b) { b.classList.add('is-added'); });
        setTimeout(function () { buttons.forEach(function (b) { b.classList.remove('is-added'); }); }, 2000);
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        openDrawerRetry(data, 12);
      }).catch(function () {
        form.submit();
      }).then(function () {
        busy = false;
        buttons.forEach(function (b) { b.classList.remove('is-loading'); });
      });
    });
  }

  /* Sticky ATC: visibile quando il buy box e' fuori schermo e la CTA finale non e' visibile */
  if (sticky && atc) {
    var finalBtn = root.querySelector('[data-final-atc]');
    var stickyBtn = sticky.querySelector('button');
    var ticking = false, last = null;
    function upd() {
      ticking = false;
      var vh = window.innerHeight;
      var a = atc.getBoundingClientRect();
      var f = finalBtn ? finalBtn.getBoundingClientRect() : null;
      var finalVisible = f ? (f.top < vh && f.bottom > 0) : false;
      var on = a.bottom < 0 && !finalVisible;
      if (on === last) return;
      last = on;
      sticky.classList.toggle('is-on', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (stickyBtn) stickyBtn.tabIndex = on ? 0 : -1;
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    upd();
  }

  /* Reveal soft: solo transform/opacity, disattivato con reduced motion */
  if (!reduce && 'IntersectionObserver' in window) {
    var items = root.querySelectorAll('[data-reveal]');
    root.classList.add('js-ready');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        var sibs = el.parentNode ? Array.prototype.indexOf.call(el.parentNode.children, el) : 0;
        el.style.transitionDelay = Math.min(sibs, 5) * 40 + 'ms';
        el.classList.add('in');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }
})();
